import React, { Component } from 'react'
import ForgotPasswordRequest from '../../components/forgotpassword/ForgotPasswordRequest';
import ForgotPasswordEmail from '../../components/forgotpassword/ForgotPasswordEmail';
import ForgotPasswordReset from '../../components/forgotpassword/ForgotPasswordReset';
import ForgotPasswordResetDone from '../../components/forgotpassword/ForgotPasswordResetDone';

export class ForgotPasswordContainer extends Component {
  handleSubmit = async (values) => {
    let res = await this.props.forgot_password_request(values);
    return res
  };

  handleResetSubmit = async (values) => {
    const {token} = this.props;
    let payload = {
      "request_body" : values,
      "token" : token
    }
    let res = await this.props.reset_password(payload);
    return res
  };
  componentWillUnmount(){
    this.props.setResetState();
  }
  parseJwt = (token) => {
    try {
      if (!token){
        return null
      }
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };
  handleClickShowPassword = (is_show) => {
    this.props.setShowPassword(is_show)
  };

  render() {
    const {request_type,forgot_password_is_loading,show_password,token,company_details} = this.props;
    if (request_type === 'reset'){
      let data = this.parseJwt(token);
      if (!data || data.token_type !== 'forgot-password'){
        window.location.replace('/');
      }
      if (Date.now() >= data.exp * 1000){
        window.location.replace('/');
      }
    }

    return (
      <>
        {
          request_type === 'request' ?
          <ForgotPasswordRequest
          forgot_password_request = {this.handleSubmit}
          is_loading = {forgot_password_is_loading}
          company_details = {company_details}
          /> 
          : request_type === 'email' 
          ? <ForgotPasswordEmail company_details = {company_details} /> 
          : request_type === 'reset' 
          ? <ForgotPasswordReset
            reset_password = {this.handleResetSubmit}
            is_loading = {forgot_password_is_loading}
            show_password = {show_password}
            handleClickShowPassword = {this.handleClickShowPassword}
            company_details = {company_details}
            />
          : request_type === 'resetdone'
          ? <ForgotPasswordResetDone company_details = {company_details}/>
          : null
        }
      </>
    )
  }
}

export default ForgotPasswordContainer;
